<div class="npo-search-info">

  <!-- POPOVER TEMPLATE  -->
  <ng-template #popoverDesc
    let-desc="desc">
    {{ desc }}
  </ng-template>

  <!-- REGISTRATION AUTHORITY  -->
  @if (!!registrationAuthority) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="common:lblRegistrationAuthority">
        </yc-i18n>
        @if (showPopovers) {
          <button
            class="popover-link"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            [popover]="popoverDesc"
        [popoverContext]="{
          desc: regAuthPopover
        }"
            [outsideClick]="true"
            [placement]="popoverPlacement">
            <yc-fa class="text-link ms-2 icon-popover"
              icon="info-circle"
              [light]="true">
            </yc-fa>
          </button>
        }
      </dt>
      <dd>
        {{ registrationAuthority }}
      </dd>
    </dl>
  }

  <!-- YC CHARITY ID  -->
  @if (!!ycCharityId) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="nonprofit:lblYCCharityID"
          defaultValue="YC Charity ID">
        </yc-i18n>
      </dt>
      <dd>
        {{ ycCharityId }}
      </dd>
    </dl>
  }
  @if (foundationCodeDesc) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="nonprofits:textFoundationType"
          defaultValue="Foundation type">
        </yc-i18n>
      </dt>
      <dd>
        {{ foundationCodeDesc }}
      </dd>
    </dl>
  }
  @if (subsectionCodeDesc) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="nonprofits:textSubsectionCode"
          defaultValue="Subsection code">
        </yc-i18n>
      </dt>
      <dd>
        {{ subsectionCodeDesc }}
      </dd>
    </dl>
  }

  <!-- IS ACTIVE  -->
  @if (isActive !== null) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="changeTracking:textIsActive"
          defaultValue="Is active">
        </yc-i18n>
        @if (isActive && showPopovers) {
          <button
            class="popover-link"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            [popover]="popoverDesc"
        [popoverContext]="{
          desc: isActivePopover
        }"
            [outsideClick]="true"
            [placement]="popoverPlacement">
            <yc-fa class="text-link ms-2 icon-popover"
              icon="info-circle"
              [light]="true">
            </yc-fa>
          </button>
        }
        @if (!isActive && showPopovers) {
          <a
            class="text-info"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            href="javascript:void(0)"
            (click)="openModal.emit(NonprofitSearchStatsModalType.NotActive)">
            <yc-fa class="text-link ms-2 icon-popover"
              icon="info-circle"
              [light]="true">
            </yc-fa>
          </a>
        }
      </dt>
      <dd>
        <yc-fa
          [icon]="isActive ? 'check-circle' : 'times-circle'"
          [class.text-success]="isActive"
          [class.text-danger]="!isActive">
        </yc-fa>
        @if (isActive) {
          <yc-i18n
            key="common:textYes">
          </yc-i18n>
        }
        @if (!isActive) {
          <yc-i18n
            key="common:textNo">
          </yc-i18n>
        }
      </dd>
    </dl>
  }

  <!-- ELIGIBLE FOR GIVING  -->
  @if (!!eligibleForGivingStatusId) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="nonprofits:textIsEligibleForGiving"
          defaultValue="Is eligible for giving">
        </yc-i18n>
        @if (showPopovers) {
          <a
            class="text-info"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            href="javascript:void(0)"
        (click)="
          eligibleForGivingStatusId === BBGFEligibleStatusId.IsEligible ?
            openModal.emit(NonprofitSearchStatsModalType.BBGFEligible) :
          eligibleForGivingStatusId === BBGFEligibleStatusId.NotEligibleButCanBe ?
            openModal.emit(NonprofitSearchStatsModalType.NeedsVetting) :
          eligibleForGivingStatusId === BBGFEligibleStatusId.AwaitingReview ?
            openModal.emit(NonprofitSearchStatsModalType.BBGFAwaitingReview) :
            openModal.emit(NonprofitSearchStatsModalType.NoGiving)
        ">
            <yc-fa class="text-link ms-2 icon-popover"
              icon="info-circle"
              [light]="true">
            </yc-fa>
          </a>
        }
      </dt>
      <dd>
        <yc-fa
        [icon]="(eligibleForGivingStatusId === BBGFEligibleStatusId.IsEligible) ?
            'check-circle' :
          (eligibleForGivingStatusId === BBGFEligibleStatusId.NotEligibleButCanBe ||
            eligibleForGivingStatusId === BBGFEligibleStatusId.AwaitingReview) ?
            'question-circle' :
          (eligibleForGivingStatusId === BBGFEligibleStatusId.NeverEligible) ?
            'times-circle' :
            ''"
          [class.text-success]="eligibleForGivingStatusId === BBGFEligibleStatusId.IsEligible"
        [class.text-warning]="eligibleForGivingStatusId === BBGFEligibleStatusId.NotEligibleButCanBe ||
          eligibleForGivingStatusId === BBGFEligibleStatusId.AwaitingReview"
          [class.text-danger]="eligibleForGivingStatusId === BBGFEligibleStatusId.NeverEligible">
        </yc-fa>
        <yc-i18n
        [key]="
          eligibleForGivingStatusId === BBGFEligibleStatusId.IsEligible ?
            'common:textYes' :
          eligibleForGivingStatusId === BBGFEligibleStatusId.AwaitingReview ?
            'common:lblVettingInProgress' :
          eligibleForGivingStatusId === BBGFEligibleStatusId.NotEligibleButCanBe ?
            'common:textNeedsVetting' :
            'common:textNo'
        ">
        </yc-i18n>
      </dd>
    </dl>
  }

  <!-- ELIGIBLE FOR DISBURSEMENT  -->
  @if (eligibleForDisbursement !== null) {
    <dl
      class="dl-horizontal">
      <dt>
        <yc-i18n
          key="nonprofits:textIsEligibleForDisbursement"
          defaultValue="Is eligible for disbursement">
        </yc-i18n>
        @if (eligibleForDisbursement && showPopovers) {
          <button
            class="popover-link"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            [popover]="popoverDesc"
        [popoverContext]="{
          desc: disbursementPopover
        }"
            [outsideClick]="true"
            [placement]="popoverPlacement">
            <div class="text-link">
              <yc-fa class="text-link ms-2 icon-popover"
                icon="info-circle"
                [light]="true">
              </yc-fa>
            </div>
          </button>
        }
        @if (!eligibleForDisbursement && showPopovers) {
          <a
            class="text-info"
            href="javascript:void(0)"
            [attr.aria-label]="'common:btnInfo' | ycI18n"
            (click)="openModal.emit(NonprofitSearchStatsModalType.NoDisbursement)">
            <yc-fa class="text-link ms-2 icon-popover"
              icon="info-circle"
              [light]="true">
            </yc-fa>
          </a>
        }
      </dt>
      <dd>
        <yc-fa
        [icon]="eligibleForDisbursement ?
          'check-circle' :
          'times-circle'"
          [class.text-success]="eligibleForDisbursement"
          [class.text-danger]="!eligibleForDisbursement">
        </yc-fa>
        @if (eligibleForDisbursement) {
          <yc-i18n
            key="common:textYes">
          </yc-i18n>
        }
        @if (!eligibleForDisbursement) {
          <yc-i18n
            key="common:textNo">
          </yc-i18n>
        }
      </dd>
    </dl>
  }
</div>